import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import GenericRoutes from "./Routes";

function App() {
  return (
    <div>
      <Header />
      <GenericRoutes />
      <Footer />
    </div>
  );
}

export default App;
